import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class FeedBackService {

  constructor(private snackBar: MatSnackBar) { }

  showMessage(message) {
    this.snackBar.open(message, null, {
      duration: 2000,
      verticalPosition: 'top'
    });
  }

  showError(message) {
    this.snackBar.open(message, null, {
      duration: 2000,
      verticalPosition: 'top'
    });
  }
}
